/**
 * Occupancy-related constants shared across the app.
 * Used for last-minute booking assumptions (bookings made within ~2 days of check-in).
 */
export const OCCUPANCY_CONFIG = {
  /** Multiplier applied to observed occupancy to get occupancy with last-minute assumed. Divide by this to reverse. */
  lastMinuteUpliftMultiplier: 1.2,
} as const;

/**
 * Converts occupancy with last-minute booking assumed → observed occupancy without last-minute assumed.
 * Use when you need the lower bound (confirmed-only, no last-minute uplift).
 */
export const getOccupancyWithoutLastMinuteAssumed = (occupancyWithLastMinuteAssumed: number): number =>
  Math.round(occupancyWithLastMinuteAssumed / OCCUPANCY_CONFIG.lastMinuteUpliftMultiplier);

/** Same as getOccupancyWithoutLastMinuteAssumed but uses Math.floor. Use when stacking chart segments. */
export const getOccupancyWithoutLastMinuteAssumedFloor = (occupancyWithLastMinuteAssumed: number): number =>
  Math.floor(occupancyWithLastMinuteAssumed / OCCUPANCY_CONFIG.lastMinuteUpliftMultiplier);
